import React from 'react';

export default function CartLineItem({ item, onIncrement, onDecrement, onRemove, atCapacity }) {
	return (
		<div className="cart-line-item">
		  <div className="cart-line-item__name">
			<div>{item.itemName} — {item.size}{item.customizations?.length > 0 ? ` (${item.customizations.join(', ')})` : ''}</div>
		  </div>
		  <div className="cart-line-item__qty-controls">
			<button onClick={() => onDecrement(item.id)}
			  className="btn-qty btn-qty--sm">−</button>
			<span className="cart-qty-display">{item.quantity}</span>
			<button onClick={() => onIncrement(item.id)} disabled={atCapacity}
			  className="btn-qty btn-qty--sm">+</button>
		  </div>
		  <span className="cart-line-total">${item.lineTotal.toFixed(2)}</span>
		  <button onClick={() => onRemove(item.id)} className="btn-cart-remove">✕</button>
		</div>
  );
}